<div class="margin-content">
  <h1 i18n class="title-page">Reset my password</h1>

  <form role="form" (ngSubmit)="resetPassword()" [formGroup]="form">
    <div class="form-group">
      <label i18n for="password">Password</label>

      <my-input-text
        formControlName="password" inputId="password" i18n-placeholder placeholder="Password"
        [formError]="formErrors['password']" autocomplete="new-password"
      ></my-input-text>
    </div>

    <div class="form-group">
      <label i18n for="password-confirm">Confirm password</label>

      <my-input-text
        formControlName="password-confirm" inputId="password-confirm" i18n-placeholder placeholder="Confirmed password"
        [formError]="formErrors['password-confirm']" autocomplete="new-password"
      ></my-input-text>
    </div>

    <input
      class="peertube-button orange-button" type="submit" i18n-value value="Reset my password"
      [disabled]="!form.valid || !isConfirmedPasswordValid()"
    >
  </form>
</div>
